import Luiv3Constants from '@app/lui3/constants';
import styled from 'styled-components';

import EmailScreen from './EmailScreen';
import LoginScreen from './LoginScreen';
import {
  RoamingSettingsProvider,
  useRoamingSettings,
} from './RoamingSettingsContext';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  background-color: ${Luiv3Constants.baseColor['gray-50']};
  padding: 1rem;
`;

const Content = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  border: 1px solid ${Luiv3Constants.baseColor['gray-200']};
  background-color: ${Luiv3Constants.baseColor['gray-0']};
  border-radius: 0.5rem;
`;

const AppShell = () => {
  const {podUrl, refreshToken} = useRoamingSettings();

  const isSignedIn = Boolean(refreshToken && podUrl);
  return (
    <Wrapper>
      <Content>{isSignedIn ? <EmailScreen /> : <LoginScreen />}</Content>
    </Wrapper>
  );
};

const App = () => (
  <RoamingSettingsProvider>
    <AppShell />
  </RoamingSettingsProvider>
);

export default App;
